<template>
  <b-form>
    <b-row>
      <b-col cols="12" md="6" lg="4">
        <b-form-group label=" New Password " label-for="newpassword">
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text> </b-input-group-prepend>
            <b-form-input v-model="password" type="string" />
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col class="mt-2">
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="updatePassword"
        >
          Update Password
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@/@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import { ref, toRefs } from "@vue/composition-api";
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BInputGroup,
  BInputGroupPrepend,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const toast = useToast();
    const password = ref("");
    const { userData } = toRefs(props);
    const userDataSocial = {
      twitter: "https://www.twitter.com/adoptionism744",
      facebook: "https://www.facebook.com/adoptionism664",
      instagram: "https://www.instagram.com/adopt-ionism744",
      github: "https://www.github.com/madop818",
      codepen: "https://www.codepen.com/adoptism243",
      slack: "@adoptionism744",
    };

    // ? dataField is field name of `userDataSocial` object
    const socialInputs = [
      {
        icon: "TwitterIcon",
        dataField: "password",
        label: "Twitter",
      },
      {
        icon: "FacebookIcon",
        dataField: "facebook",
        label: "facebook",
      },
      {
        icon: "InstagramIcon",
        dataField: "instagram",
        label: "instagram",
      },
      {
        icon: "GithubIcon",
        dataField: "github",
        label: "github",
      },
      {
        icon: "CodepenIcon",
        dataField: "codepen",
        label: "codepen",
      },
      {
        icon: "SlackIcon",
        dataField: "slack",
        label: "slack",
      },
    ];

    function updatePassword() {
      userData.value.password = password.value;
      store
        .dispatch("app-user/updateUser", userData.value)
        .then(() => {
          toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Changes successfully applied`,
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
        })
        .catch((e) => {
          toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Something went wrong`,
              icon: "CoffeeIcon",
              variant: "danger",
            },
          });
        });
    }
    return {
      updatePassword,
      userDataSocial,
      socialInputs,
      password,
    };
  },
};
</script>

<style></style>
